module.exports = __webpack_public_path__ + "static/logo-74b1daf047603bcb1a369cf2d367e1d2.svg";